module.exports = __webpack_public_path__ + "static/media/0002.8ce09e46.jpg";